export const signOutNative = (callback) => {
  callback()
}

export const configureNativeSignIn = () => {}
